import type {ReactElement} from 'react';
import React from 'react';
import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import {LazyMasonryGrid} from '@Components/lazy-masonry-grid';
import {USER_VIDEO_UPLOADS_GRID_ID} from '@Panels/user-media-panel/user-media-panel.types';
import type {LazyLoadingGetterParams, LazyLoadingResponse} from '@Libraries/pmw-stock-media-library';

interface VideosGridProps {
  className: string;
  gridSelectionGroupId: string;
  excludeItemWithExtension?: string;
  maxSelectionNumber?: number;
  scrollingContainer: HTMLDivElement | null;

  getItems(getterParams: LazyLoadingGetterParams): Promise<LazyLoadingResponse>;

  onGridItemClicked(item: GridItemStorage, isDoubleClick: boolean): void;
}

export function VideosGrid({...props}: VideosGridProps): ReactElement {
  return (
    <LazyMasonryGrid
      className={props.className}
      gridId={USER_VIDEO_UPLOADS_GRID_ID}
      gridSelectionGroupId={props.gridSelectionGroupId}
      getItems={(getterParams): Promise<LazyLoadingResponse> => {
        return props.getItems(getterParams);
      }}
      excludeItemWithExtension={props.excludeItemWithExtension}
      onAllItemsLoaded={(): void => {}}
      maxSelectionNumber={props.maxSelectionNumber}
      customOnGridItemClicked={(item: GridItemStorage, isDoubleClick: boolean): void => {
        return props.onGridItemClicked(item, isDoubleClick);
      }}
      clearGridOnUnmount
      makeContentScrollable={false}
      scrollingContainer={props.scrollingContainer}
    />
  );
}
